module.exports = __webpack_public_path__ + "img/icon-member-red.fc88b75a.png";